import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ChatMemoryListDto } from 'src/api/FiretrolApiClient';
import { chatMemoryApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import {
  CHAT_QUERY_CACHE_TIME,
  CHAT_QUERY_STALE_TIME,
} from 'src/api/queries/chat/useChatConversationQueries';

/** The signed-in user's memory setting and notes in every status. Pass `enabled` rather than varying the key, so cached notes keep rendering. */
export function useChatMemoryQuery(
  enabled = true,
): UseQueryResult<ChatMemoryListDto> {
  return useQuery({
    queryKey: queryKeys.chat.memory(),
    queryFn: ({ signal }) => chatMemoryApiClient.list(toCancelToken(signal)),
    enabled,
    staleTime: CHAT_QUERY_STALE_TIME,
    gcTime: CHAT_QUERY_CACHE_TIME,
    refetchOnWindowFocus: false,
    meta: { errorContext: 'chat memory' },
  });
}

export function useUserChatMemoryQuery(
  userId: number,
): UseQueryResult<ChatMemoryListDto> {
  return useQuery({
    queryKey: queryKeys.chatAdmin.userMemory(userId),
    queryFn: ({ signal }) =>
      chatMemoryApiClient.listForUser(userId, toCancelToken(signal)),
    enabled: Number.isFinite(userId),
    meta: { errorContext: 'user chat memory' },
  });
}
